/**
 * Fantasy Console 0 - Skeleton Loading Components
 *
 * Provides skeleton placeholders for loading states.
 */

import styles from './Skeleton.module.css'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  borderRadius?: string | number
  className?: string
  style?: React.CSSProperties
}

export function Skeleton({
  width,
  height,
  borderRadius,
  className = '',
  style = {},
}: SkeletonProps) {
  return (
    <div
      className={`${styles.skeleton} ${className}`}
      style={{
        width,
        height,
        borderRadius,
        ...style,
      }}
    />
  )
}

interface SkeletonTextProps {
  width?: string | number
  height?: string | number
  className?: string
  style?: React.CSSProperties
}

export function SkeletonText({
  width = '100%',
  height = '1em',
  className = '',
  style = {},
}: SkeletonTextProps) {
  return (
    <div
      className={`${styles.skeletonText} ${className}`}
      style={{
        width,
        height,
        ...style,
      }}
    />
  )
}

interface SkeletonCircleProps {
  size?: string | number
  className?: string
  style?: React.CSSProperties
}

export function SkeletonCircle({
  size = 32,
  className = '',
  style = {},
}: SkeletonCircleProps) {
  return (
    <div
      className={`${styles.skeletonCircle} ${className}`}
      style={{
        width: size,
        height: size,
        ...style,
      }}
    />
  )
}
